import { FormGroup } from '@angular/forms';

// Generic validator for Reactive forms
// Implemented as a class, not a service, so it can retain state for multiple forms.
export class GenericValidator {

    // Provide the set of valid validation messages
    // Stucture:
    // controlName1: {
    //     validationRuleName1: 'Validation Message.',
    //     validationRuleName2: 'Validation Message.'
    // },
    // controlName2: {
    //     validationRuleName1: 'Validation Message.',
    //     validationRuleName2: 'Validation Message.'
    // }
    constructor(private validationMessages: { [key: string]: { [key: string]: string } }) {

    }

    // Processes each control within a FormGroup
    // And returns a set of validation messages to display
    // Structure
    // controlName1: 'Validation Message.',
    // controlName2: 'Validation Message.'
    processMessages(container: FormGroup): { [key: string]: string } {
        let messages = {};
        for (let controlKey in container.controls) {
            
            //console.log('GenericValidator.processMessages() >> controlKey:' + controlKey);

            if (!(container.controls.hasOwnProperty(controlKey))) {
                continue;
            }

            let c = container.controls[controlKey];
            // If it is a FormGroup, process its child controls.
            if (c instanceof FormGroup) {
                let childMessages = this.processMessages(c);
                Object.assign(messages, childMessages);
            } else {
                // Only validate if there are validation messages for the control
                if (!(this.validationMessages[controlKey])) 
                {
                    continue;
                }
                
                messages[controlKey] = '';

                if (!((c.dirty || c.touched) && c.errors)) {
                    continue;
                }

                Object.keys(c.errors).map(messageKey => {

                    if (this.validationMessages[controlKey][messageKey]) {
                        messages[controlKey] += this.validationMessages[controlKey][messageKey] + ' ';
                    }else{
                        console.warn('GenericValidator.processMessages >> There is a validation violation but could not find a corresponding message for it. Check casing. messagekey:' + messageKey);
                    }
                });
            }

        }
        return messages;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/generic-validator.ts